(() => {
  if (customElements.get('pd2-details-view')) return;

  customElements.define('pd2-details-view', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.initialize());
    }

    initialize() {
      this.specs = this.querySelector('.pd2-details__specs');
      this.image = this.querySelector('.pd2-details__mob img');
      this.button = this.querySelector('.pd2-details__expand');
      this.compare = this.querySelector('[data-details-compare]');
      if (!this.specs || !this.image || !this.button || !this.compare) return;

      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.mobile = matchMedia('(max-width: 767px)');
      const schedule = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      };
      this.addEventListener('change', (event) => {
        if (!event.target.matches('input[type="radio"]')) return;
        this.setExpanded(false);
        schedule();
      }, options);
      this.button.addEventListener('click', () => {
        const collapsing = this.hasAttribute('data-expanded');
        this.setExpanded(!collapsing);
        this.update();
        if (collapsing) {
          const rect = this.button.getBoundingClientRect();
          if (rect.top < 0 || rect.bottom > innerHeight) {
            this.button.scrollIntoView({ block: 'nearest', behavior: 'instant' });
          }
        }
      }, options);
      this.image.addEventListener('load', schedule, options);
      this.image.addEventListener('error', () => {
        this.removeAttribute('data-foldable');
        this.button.hidden = true;
      }, options);
      this.mobile.addEventListener('change', schedule, options);
      this.observer = new ResizeObserver(schedule);
      [this.specs, this.image, this.button].forEach(node => this.observer.observe(node));
      this.update();
    }

    setExpanded(expanded) {
      this.toggleAttribute('data-expanded', expanded);
      this.button.setAttribute('aria-expanded', String(expanded));
      this.button.querySelector('[data-expand-label]').hidden = expanded;
      this.button.querySelector('[data-collapse-label]').hidden = !expanded;
    }

    update() {
      if (!this.mobile.matches || !this.compare.checked) {
        this.removeAttribute('data-foldable');
        this.button.hidden = true;
        this.setExpanded(false);
        return;
      }
      // The inactive specifications retain their layout for an accurate height.
      const targetHeight = this.specs.getBoundingClientRect().height;
      const imageHeight = this.image.getBoundingClientRect().height;
      if (targetHeight < 160 || imageHeight <= targetHeight + 1) {
        this.removeAttribute('data-foldable');
        this.button.hidden = true;
        this.setExpanded(false);
        return;
      }
      this.button.hidden = false;
      const previewHeight = Math.max(1, targetHeight - this.button.getBoundingClientRect().height);
      this.style.setProperty('--details-preview-height', `${previewHeight}px`);
      this.setAttribute('data-foldable', '');
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.controller?.abort();
      this.observer?.disconnect();
    }
  });
})();
